import { Component, input, output } from '@angular/core';

import { Duration } from './duration/duration.pipe';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[meeting-analysis-video-jump]', // having a regular selector here causes li's to mess up the styling
  styleUrls: ['./video-jump.component.scss'],
  templateUrl: './video-jump.component.html',
  imports: [Duration],
})
export class VideoJumpComponent {
  text = input<string>('');
  duration = input<number>(0);

  jumpToTimestamp = output<number>();

  clicked(): void {
    this.jumpToTimestamp.emit(this.duration());
  }
}
